import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../../../utils/media-queries';
import RichText from '../../molecules/richtext';

const Copy = ({ copyLeft, copyRight }) => (
  <StyledCopy className="grid">
    {copyLeft && (
      <div className="left">
        <RichText blocks={copyLeft} />
      </div>
    )}
    <div className="right">
      <RichText blocks={copyRight} />
    </div>
  </StyledCopy>
);

const StyledCopy = styled.section`
  padding-top: var(--v-spacing-L);
  margin-bottom: calc(var(--v-spacing-L) * 2);
  color: var(--blue);

  p {
    padding-bottom: var(--spacing-XS);
  }

  .left {
    padding-bottom: var(--spacing-XS);
  }

  .left,
  .right {
    grid-column: 1 / 20;
  }

  strong {
    font-family: var(--font-2);
    font-weight: normal;
  }

  a {
    :before {
      content: '→  ';
    }
  }

  @media ${media.L} {
    .left {
      grid-column: 5 / 13;
    }

    .right {
      grid-column: 14 / 22;
    }
  }
`;

Copy.propTypes = {
  copyLeft: PropTypes.array,
  copyRight: PropTypes.array,
};

export default Copy;
